import React, { type FC } from 'react';

import {
  Box,
  type BoxProps,
  Icon as ChakraIcon,
  type IconProps as ChakraIconProps,
  type ComponentWithAs,
  forwardRef,
} from '@chakra-ui/react';

export type IconProps = BoxProps & {
  icon:
    | ComponentWithAs<'svg', ChakraIconProps>
    | FC<React.PropsWithChildren<unknown>>;
  iconProps?: ChakraIconProps;
};

export const Icon = forwardRef<IconProps, 'span'>(
  ({ icon: IconEl, iconProps, ...rest }, ref) => {
    return (
      <Box
        as="span"
        display="inline-block"
        position="relative"
        w="1em"
        flex="none"
        _before={{
          content: '"."',
          visibility: 'hidden',
        }}
        ref={ref}
        {...rest}
      >
        <ChakraIcon
          as={IconEl}
          w="1em"
          h="1em"
          position="absolute"
          top="50%"
          left="50%"
          transform="translate(-50%, -50%)"
          {...iconProps}
        />
      </Box>
    );
  }
);
